import moment from 'moment';

class PagosRequestInputTransformer {
  getName() {
    return 'pagos';
  }

  make(input) {
    const { Complemento } = input;

    if (!Complemento || !Complemento.Pagos) {
      return input;
    }

    input.SubTotal = 0;
    input.Total = 0;
    input.Moneda = 'XXX';
    input.Clasificacion = 2;
    input.Exportacion = '01';
    input.TipoDeComprobante = 'Pago';

    input.Conceptos = {
      Concepto: [
        {
          ClaveProdServ: '84111506',
          Cantidad: '1',
          ClaveUnidad: 'ACT',
          Unidad: 'Actividad',
          Descripcion: 'Pago',
          ValorUnitario: '0',
          Importe: '0',
          Descuento: '0',
        },
      ],
    };

    const { Pagos } = Complemento;

    const newPagos = [];

    for (const pago of Pagos.Pago || []) {
      newPagos.push({
        ...pago,
        TipoCambioP: !pago.TipoCambioP && pago.MonedaP === 'MXN' ? '1' : pago.TipoCambioP,
        FechaPago: moment(pago.FechaPago).format('YYYY-MM-DD') + 'T' + (pago.HoraPago ?? '12:00') + ':00',
        HoraPago: undefined,
        DoctoRelacionado: pago.DoctoRelacionado.map((documento) => {
          return {
            ...documento,
            EquivalenciaDR: !documento.EquivalenciaDR && documento.MonedaDR === 'MXN' ? '1' : documento?.EquivalenciaDR,
          };
        }),
      });
    }

    input.Complemento = {
      ...Complemento,
      Pagos: {
        ...Pagos,
        Pago: newPagos,
      },
    };

    return input;
  }
}

export default PagosRequestInputTransformer;
